import { selectOptionsListHappy } from "@/happyTheme/event/product/selectOptionsListHappy";

export function clearSelectOptionListHappy() {
    selectOptionsListHappy.value = {}
}